import React from 'react';

/**
 * Hook to simplify how forms embedded in components can be triggered by
 * a component further up the hierarchy.
 * @returns
 */
export default function useFormikOrchestration() {
  /** @type {()=>void} */
  let submitFormFunction = () => {};

  const [isValid, setIsValid] = React.useState(/** @type {boolean} */ (false));

  const setFormikContext = ({ submitForm, isValid: formikIsValid }) => {
    submitFormFunction = submitForm;
    setIsValid(formikIsValid);
  };

  function triggerSubmit() {
    submitFormFunction();
  }

  return {
    setFormikContext,
    triggerSubmit,
    isValid,
  };
}
